/* src/app/feedback-question/template-key-modal/template-key-modal.component.scss */
.modal-body {
  text-align: left;
}
.modal-header {
  position: relative;
}
.modal-title {
  padding-right: 32px;
}
.close {
  position: absolute;
  top: 12px;
  right: 16px;
  padding: 0;
  margin: 0;
  width: 28px;
  height: 28px;
  line-height: 1;
  background: none;
  border: 0;
  border-radius: 50%;
  color: black;
  opacity: 0.5;
  font-size: 1.5rem;
}
.close:hover,
.close:focus {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06);
  outline: none;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  text-align: left;
}
.form-control {
  color: black !important;
  background-color: white !important;
  height: auto;
  padding: 8px 12px;
  text-overflow: ellipsis;
}
.template-key-field {
  width: 100%;
}
.template-key-field ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 0;
}
.template-key-field ::ng-deep .mat-mdc-text-field-wrapper {
  padding-left: 12px;
  padding-right: 12px;
}
.template-key-field ::ng-deep input {
  text-overflow: ellipsis;
}
.rename-toggle {
  cursor: pointer;
  font-size: 0.9rem;
  color: #3366cc;
}
.rename-toggle:hover {
  color: #254e99;
  text-decoration: underline;
}
/*# sourceMappingURL=template-key-modal.component.css.map */
